<template>
    <div class="login-form">
        <h4 class="mb-1">
            {{ lang.title }}
        </h4>

        <facebook-login-button v-if="login_social.facebook" @signedin="onLoginSuccess" />

        <google-login-button v-if="login_social.google" @signedin="onLoginSuccess" />

        <apple-login-button v-if="login_social.apple" @signedin="onLoginSuccess" />

        <div class="separator">{{ lang.or }}</div>

        <form @submit.prevent="login" @keydown="form.errors.clear($event.target.name)">
            <my-input
                v-model="form.email"
                name="email"
                type="email"
                :label="lang.placeholders.email"
            />

            <error-span :error="form.errors.get('email')"></error-span>

            <my-input
                v-model="form.password"
                name="password"
                type="password"
                :label="lang.placeholders.password"
            />
            <div class="row">
                <div class="col">
                    <div class="password_recovery">
                        <a :href="lang.password_recovery_url" class="btn btn-text">                    
                            {{ lang.labels.password_recovery|capitalize }}                  
                        </a>            
                    </div>
                </div>
                <div class="col" v-if="$root.country == 'it'">
                    <div class="privacy_link">
                        <a href="/privacy/login.html" class="btn btn-text">                    
                            {{ lang.labels.privacy|capitalize }}                  
                        </a>            
                    </div>
                </div>
            </div>
            

            <error-span :error="form.errors.get('password')"></error-span>

            <button class="btn btn-network" :disabled="form.errors.any()">
                {{ lang.labels.login }}
            </button>
        </form>

    </div>
</template>

<script>
import { Form } from '../classes/Form'

import AppleLoginButton from './AppleLoginButton.vue'
import FacebookLoginButton from './FacebookLoginButton.vue'
import GoogleLoginButton from './GoogleLoginButton.vue'

export default {
    components: {
        'apple-login-button': AppleLoginButton,
        'facebook-login-button': FacebookLoginButton,
        'google-login-button': GoogleLoginButton,
    },

    props: {
        triggers_an_action: {
            type: Boolean,
            default: false,
        },

        target: {
            type: String,
            default: 'dashboard',
        },

        login_social: {
            type: Object,
            require: true,
        }
    },

    data() {
        return {
            error: '',
            form: new Form({
                email: '',
                password: '',
            }),
            message: '',
            rules: {
                email: ['required'],
                password: ['required'],
            }
        }
    },

    computed: {
        lang() {
            return this.$root.lang.login_form
        },
    },

    methods: {
        login() {
            if(! this.form.validate(this.rules)) {
                return false
            }

            this.form.post('/api/login')
                .then(data => {
                    this.onLoginSuccess(data)
                })
                .catch(response => {
                    if(response.status !== 419) {
                        flash(response.data.message, 'warning')
                        this.error = this.lang.errors.authentication
                    }
                })
        },

        onLoginSuccess(data) {
            if (data.hash) {
                this.$root.user_hash = data.hash
                this.$root.user_email = data.email

                if(this.triggers_an_action) {
                    window.events.$emit('hideModal', { name: 'login' })

                    window.events.$emit('login_completed')
                }
                else {
                    let target = this.target ? this.target : 'dashboard'

                    location.href = this.lang.user_area_routes[target]
                }
            } else {
                flash(this.lang.messages.register)
                this.$parent.close()
            }
        },
    },
}
</script>